import PaymentLogWidgetContainer from './PaymentLogWidget';

export default PaymentLogWidgetContainer;
